import React from 'react';
import {OrderContext} from "./OrderContext";
import useOrder from "./useOrder";

const OrderProvider = (props) => {
    const model = useOrder();
    return <OrderContext.Provider value={model} {...props} />;
};

export default OrderProvider;